import { reportsSliceActions } from './reportsSlice';
import { showErrorMessage, showSuccessMessage } from '../../../../../../../helpers/utils/ui';
import { unApi } from '../../../../../../../shared/common/api/endpoints/reports/unApi';
import { handleResponseError } from '../../../../../../../shared/common/api/middleware';
import { TAppDispatch } from '../../../../store';
import { tableSliceActions } from '../../table/tableSlice';

export const reportsActions = {
  ...reportsSliceActions,

  getReports: (schoolId: string | number) => async (dispatch: TAppDispatch) => {
    dispatch(reportsActions.setReportsLoading(true));
    let currentLocation = location.pathname;
    unApi
      .getReports(schoolId, currentLocation)
      .then((res) => {
        if (location.pathname !== currentLocation) {
          return;
        }
        dispatch(reportsActions.setReports(res.data));
      })
      .catch((err) => {
        handleResponseError(dispatch, err);
      })
      .finally(() => {
        dispatch(reportsActions.setReportsLoading(false));
      });
  },
  getSavedReports: (schoolId: string | number, settedId?: number) => async (dispatch: TAppDispatch) => {
    dispatch(reportsActions.setReportsLoading(true));
    dispatch(reportsActions.setLoading(true));
    let currentLocation = location.pathname;
    unApi
      .getSavedReports(schoolId, currentLocation)
      .then((res) => {
        if (location.pathname !== currentLocation) {
          return;
        }
        dispatch(reportsActions.setSavedReports(res.data.reports));
        dispatch(reportsActions.setSavedDashboards(res.data.dashboards));
      })
      .catch((err) => {
        handleResponseError(dispatch, err);
      })
      .finally(() => {
        dispatch(reportsActions.setLoading(false));
        dispatch(reportsActions.setReportsLoading(false));
      });
  },
  getSavedDashboards:
    (schoolId: string | number, settedId?: number) => async (dispatch: TAppDispatch) => {
      dispatch(reportsActions.setReportsLoading(true));
      let currentLocation = location.pathname;
      unApi
        .getDashboards(schoolId, currentLocation)
        .then((res) => {
          if (location.pathname !== currentLocation) {
            return;
          }
          dispatch(reportsActions.setSavedDashboards(res.data));
        })
        .catch((err) => {
          handleResponseError(dispatch, err);
        })
        .finally(() => {
          dispatch(reportsActions.setReportsLoading(false));
        });
    },

  postReport:
  (schoolId: string | number, { values, onSuccess }: any) =>
    async (dispatch: TAppDispatch) => {

      try {
        const response = await unApi.createReport(schoolId, values, location.pathname);
        const data = response.data;
        const report_id = data['hash'];
        if (report_id) {
          onSuccess && onSuccess(report_id);
        }
        unApi
          .getSavedReports(schoolId, location.pathname)
          .then((res) => {
            dispatch(reportsActions.setSavedReports(res.data.reports));
            dispatch(reportsActions.setSavedDashboards(res.data.dashboards));
          })
          .catch((err) => {
            handleResponseError(dispatch, err);
          })
          .finally(() => {
            dispatch(reportsActions.setReportsLoading(false));
          });

        if (!report_id) {
          throw new Error('Ошибка запроса');

        }
      } catch (err: any) {
        if (err instanceof Error && err.message === 'Ошибка запроса') {
          
          return;
        }
        handleResponseError(dispatch, err);
      }
    },
  getCreatedMetrics:
    (schoolId: number | string, pathname = location.pathname) =>
      async (dispatch: TAppDispatch) => {
        unApi
          .getCustomMetrics(schoolId, pathname)
          .then((res) => {
            dispatch(tableSliceActions.setCreatedMetrics(res.data));
          })
          .catch((err) => {
            handleResponseError(dispatch, err);
          });
      },
  putReport:
    (schoolId: string | number, { id, values }: any, currentReport?: any) =>
      async (dispatch: TAppDispatch) => {
        dispatch(reportsActions.setReportsLoading(true));
        const isDashboard = location.pathname.includes('dashboards');
        // try{
          try{
            await unApi.editReport(schoolId, id, values, location.pathname);
            showSuccessMessage(`${isDashboard ? 'Дашборд' : 'Отчет'} сохранен`);
          }catch(err){
            showErrorMessage(`Ошибка сохранения ${isDashboard ? 'дашборда' : 'отчета'}`);
            return;
          }
          finally {
            dispatch(reportsActions.setReportsLoading(false));
          }
        //   await dispatch(reportsActions.getSavedReports(schoolId));
        //   if (isDashboard) {
        //     const response = await unApi.getDashboards(
        //       schoolId,
        //       location.pathname
        //     );
        //     const editedReport = response.data.find(
        //       (report: any) => report.id === id
        //     );
        //     if (editedReport.id === currentReport.id) {
        //       const { data } = await unApi.getCurrentDashboard(id);
        //       dispatch(reportsActions.setCurrentDashboard(data));
        //     }
        //   } else {
        //     const reportsResponse = await unApi.getReports(
        //       schoolId,
        //       location.pathname
        //     );
        //     const editedReport = reportsResponse.data.find(
        //       (report: any) => report.id === id
        //     );
        //     if (editedReport.id === currentReport.id) {
        //       dispatch(reportsActions.setCurrentReport(editedReport));
        //     }
        //   }
        // }
      // }
    },

  getCurrentDashboard: (id: string, callback?: (hash: string) => void) => async (dispatch: TAppDispatch) => {
    dispatch(reportsActions.setLoading(true));
    try {
      const { data } = await unApi.getCurrentDashboard(id);
      dispatch(reportsActions.setCurrentDashboard(data));
      callback && callback(data?.hash);
    } catch (err: any) {
      handleResponseError(dispatch, err);
    } finally {
      dispatch(reportsActions.setLoading(false));
    }
  },
  deleteReport:
    (schoolId: string | number, { id }: any) =>
      async (dispatch: TAppDispatch) => {
        // dispatch(reportsActions.setLoading(true));
        const pathname = location.pathname;
        try {
          await unApi.deleteReport(schoolId, id, pathname);
          const isDashboard = pathname.includes('dashboards');

          if (isDashboard) {
            dispatch(reportsActions.getSavedReports(schoolId));
            showSuccessMessage('Дашборд удален');
          } else {
            dispatch(reportsActions.getSavedReports(schoolId));
            showSuccessMessage('Отчет удален');
          }

        } catch (err: any) {
          handleResponseError(dispatch, err);
        } finally {
          window.location.reload();
        }
      },
};
